import styled from 'styled-components';
import { ReactComponent as Icon } from './DownloadButtonIcon.svg';
import React from 'react';

export const Button = styled.button<{ isDisabled?: boolean }>`
  background-color: ${(props) => (!props.isDisabled ? '#12B7E7' : 'rgba(224, 245, 251, 1)')};
  border: none;
  box-shadow: none;
  font-weight: bold;
  font-size: 13px;
  line-height: normal;
  width: 208px;
  white-space: nowrap;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  border-radius: 10px;
  padding: 11px 20px;
  transition: background-color ease 0.3s;
  &:hover {
    background-color: #00a8d9;
  }
  margin: -8px 0;
  pointer-events: ${(props) => (!props.isDisabled ? 'auto' : 'none')};
  flex: 0 0 auto;
`;

const DownloadButtonIcon = styled(Icon)`
  margin-right: 4px;
`;

const DownloadButton = ({
  children,
  ...props
}: React.PropsWithChildren<{ isDisabled?: boolean; onClick?: () => void }>) => {
  return (
    <Button {...props}>
      <DownloadButtonIcon />
      {children}
    </Button>
  );
};

export default DownloadButton;
